var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.358 39.328h31.285V17.633H8.358v21.695zm6.339-29.806v1.562h1.841V9.522h6.339v1.562h1.842V9.522h6.742v1.562h1.842V9.522h6.34v6.269H8.358V9.522h6.339zm18.606-1.843V5.75h-1.842v1.929h-6.742V5.75h-1.842v1.929h-6.339V5.75h-1.841v1.929H6.516v33.492h34.969V7.679h-8.182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.773 27.56h6.047v-5.253h-6.047v5.253zm16.408 0h6.047v-5.253h-6.047v5.253zm0 7.095h6.047v-5.253h-6.047v5.253zm-8.52-7.095h6.678v-5.253h-6.678v5.253zm0 7.096h6.678v-5.253h-6.678v5.253zm-7.888-.001h6.047v-5.253h-6.047v5.253zm-1.842 1.844H37.07V20.464H10.931v16.035z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2fed3234061723552cbf6b7d399375c8.svg";
export { ForwardRef as ReactComponent };